import { Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { ApiKeyComponent } from './pages/api-key/api-key.component';
import { CustomersComponent } from './pages/customers/customers.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { OrganizationComponent } from './pages/organization/organization.component';
import { RegisterComponent } from './pages/register/register.component';
import { RewardsComponent } from './pages/rewards/rewards.component';
import { SingleCustomerComponent } from './pages/single-customer/single-customer.component';

export const routes: Routes = [
    { path: '', component: LoginComponent },
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'organization', component: OrganizationComponent, canActivate: [AuthGuard] },
    { path: 'api-keys', component: ApiKeyComponent, canActivate: [AuthGuard] },
    { path: 'rewards', component: RewardsComponent, canActivate: [AuthGuard] },
    { path: 'customers', component: CustomersComponent, canActivate: [AuthGuard] },
    { path: 'dashboard', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'customer-details/:id', component: SingleCustomerComponent, canActivate: [AuthGuard] },
];